module.exports = __webpack_public_path__ + "static/media/2025_bws_shipping.38d535cb.png";